// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import PropTypes from 'prop-types';
import style from './BNPLSummary.sass';
import logoBnpl from '../../assets/original-icons/bancolombia-bnpl.svg';
import PaymentSummaryCommon from '../PaymentSummaryCommon/PaymentSummaryCommon';

const BNPLSummary = ({ transaction, thirdPartyCheckout }) => {
  const pm = transaction?.paymentMethod || {};
  const customerData = transaction?.customerData || {};

  const buyerName = customerData.fullName || pm.name || "";
  const buyerPhone = customerData.phoneNumber || pm.phoneNumber || "";
  const buyerEmail = transaction?.customerEmail || "";

  const additionalRows = [];
  if (buyerName) additionalRows.push({ label: 'Nombre:', value: buyerName });
  if (buyerEmail) additionalRows.push({ label: 'Email:', value: buyerEmail });
  if (buyerPhone) additionalRows.push({ label: 'Teléfono:', value: buyerPhone });

  return (
    <PaymentSummaryCommon
      transaction={transaction}
      thirdPartyCheckout={thirdPartyCheckout}
      methodLabel="Comprobante de pago Compra y Paga Después Bancolombia"
      logoSrc={logoBnpl}
      altText="BNPL"
      wrapperClassName={style.bnplPaymentMethodWrapper}
      logoClassName={style.theBnplBancolombiaLogo}
      additionalRows={additionalRows}
    />
  );
};

BNPLSummary.propTypes = {
  transaction: PropTypes.object.isRequired,
  thirdPartyCheckout: PropTypes.any,
};

export default BNPLSummary;
